'use strict';

var React = require('react');
require('prop-types');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var CancelSaveButtons = require('../CancelSaveButtons.js');
var TextField = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function TestimonialInEdit(_ref) {
  var updatedQuote = _ref.updatedQuote,
      updatedAuthor = _ref.updatedAuthor,
      updatedCity = _ref.updatedCity,
      updatedState = _ref.updatedState,
      onChangeQuote = _ref.onChangeQuote,
      onChangeAuthor = _ref.onChangeAuthor,
      onChangeCity = _ref.onChangeCity,
      onChangeState = _ref.onChangeState,
      isSaving = _ref.isSaving,
      disabled = _ref.disabled,
      _onCancelClick = _ref.onCancelClick,
      _onSaveClick = _ref.onSaveClick;
  return React__default["default"].createElement("form", {
    onSubmit: function onSubmit(event) {
      return event.preventDefault();
    }
  }, React__default["default"].createElement(Grid, {
    container: true,
    spacing: 16
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(TextField["default"], {
    value: updatedQuote,
    onChange: function onChange(event) {
      return onChangeQuote(event);
    },
    required: true,
    variant: "outlined",
    fullWidth: true,
    label: "Quote",
    multiline: true,
    rows: 4,
    autoFocus: true
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 4
  }, React__default["default"].createElement(TextField["default"], {
    value: updatedAuthor,
    onChange: function onChange(event) {
      return onChangeAuthor(event);
    },
    required: true,
    variant: "outlined",
    fullWidth: true,
    label: "Author"
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 4
  }, React__default["default"].createElement(TextField["default"], {
    value: updatedCity,
    onChange: function onChange(event) {
      return onChangeCity(event);
    },
    variant: "outlined",
    fullWidth: true,
    label: "City"
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 4
  }, React__default["default"].createElement(TextField["default"], {
    value: updatedState,
    onChange: function onChange(event) {
      return onChangeState(event);
    },
    variant: "outlined",
    fullWidth: true,
    label: "State"
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(CancelSaveButtons, {
    onCancelClick: function onCancelClick() {
      return _onCancelClick();
    },
    onSaveClick: function onSaveClick() {
      return _onSaveClick();
    },
    isSaving: isSaving,
    disabled: disabled
  }))));
}

TestimonialInEdit.defaultProps = {
  updatedQuote: '',
  updatedAuthor: '',
  updatedCity: '',
  updatedState: '',
  onChangeQuote: function onChangeQuote() {},
  onChangeAuthor: function onChangeAuthor() {},
  onChangeCity: function onChangeCity() {},
  onChangeState: function onChangeState() {},
  isSaving: false,
  disabled: false,
  onCancelClick: function onCancelClick() {},
  onSaveClick: function onSaveClick() {}
};

module.exports = TestimonialInEdit;
